export default "__VITE_ASSET__CrTSkbml__"